module.exports = __webpack_public_path__ + "static/media/diagnoses.dd180d0c.svg";